import { Component, inject } from '@angular/core';
import type { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

import { TranslatePipe } from '@core/i18n-legacy';
import type { DialogComponentI } from '@core/user-interface-legacy';
import {
  BoxComponent,
  ButtonComponent,
  DialogHeaderComponent,
  DialogRef,
  DividerComponent,
} from '@core/user-interface-legacy';

@Component({
  selector: 'rtr-terms-dialog',
  templateUrl: './terms-dialog.component.html',
  styleUrls: ['./terms-dialog.component.less'],
  imports: [DialogHeaderComponent, BoxComponent, DividerComponent, ButtonComponent, TranslatePipe],
})
export class TermsDialogComponent
  implements DialogComponentI<{ title: string; body: string }, null>
{
  private readonly dialogRef = inject<DialogRef<TermsDialogComponent>>(
    DialogRef<TermsDialogComponent>,
  );
  private readonly sanitizer = inject(DomSanitizer);
  public title: string;
  public body: SafeHtml;

  public setDialogData(data: { title: string; body: string }, triggerUpdate: boolean): void {
    this.title = data.title;
    // eslint-disable-next-line ban/ban
    this.body = this.sanitizer.bypassSecurityTrustHtml(data.body);
  }

  public close(): void {
    this.dialogRef.close();
  }
}
